<template>
  <v-card class="px-3 pb-3 pt-2">
    <v-dialog persistent max-width="300" v-model="blockScreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold"
            >Aguarde, estamos processando os dados...</span
          >
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="checkin-text"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-layout pl-4 pr-1 row justify-space-between align-center>
      <span class="title total">Detalhes da reserva:</span>
      <v-btn icon @click="changeDialog()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-divider class="mt-0"></v-divider>
    <v-card text class="vehicle my-2 pa-1">
      <div class="contentLeft">
        <span class="modelo">{{
          vehicleRequest.vehicle.vehicle_model.model
        }}</span>
        <br />
        <img
          class="vehicleImg"
          style="max-width: 186px; height: auto"
          :src="`${url_bucket}${vehicleRequest.vehicle.vehicle_model.url}`"
        />
        <br />
        <span class="body-1 total">Placa:</span>
        <span class="pl-2 body-1 total">{{
          vehicleRequest.vehicle.plate
        }}</span>
        <br />
      </div>
      <div class="contentRight pt-1 pl-4">
        <div class="pb-1">
          <img src="../../assets/icons/icon2.png" />
          <span class="pl-2 caption">{{
            vehicleRequest.vehicle.gearbox ? 'Automático' : 'Manual'
          }}</span>
        </div>
        <div class="pb-1">
          <img src="../../assets/icons/icon3.png" />
          <span class="pl-2 caption">Flex</span>
        </div>
        <div class="pb-1">
          <img src="../../assets/icons/icon4.png" />
          <span class="pl-2 caption"
            >{{ vehicleRequest.vehicle.doors_qtd }} Portas</span
          >
        </div>
        <div class="pb-1">
          <img src="../../assets/icons/icon5.png" />
          <span class="pl-2 caption">Ar Condicionado</span>
        </div>
      </div>
    </v-card>
    <v-divider></v-divider>
    <div class="text-center">
      <v-rating
        medium
        readonly
        v-model="rating"
        background-color="orange lighten-3"
        color="orange"
      ></v-rating>
    </div>
    <v-divider></v-divider>
    <v-layout justify-space-between>
      <span class="total font-weight-bold">Check-in:</span>
      <span class="total font-weight-regular">{{
        vehicleRequest.begin_date | normalizeDate
      }}</span>
    </v-layout>
    <v-layout class="pt-2" justify-space-between>
      <span class="total font-weight-bold">Check-out:</span>
      <span class="total font-weight-regular">{{
        vehicleRequest.end_date | normalizeDate
      }}</span>
    </v-layout>
    <div>
      <div v-if="vehicleRequest.step.code != 'check-in'">
        <v-layout class="pt-3" justify-space-between>
          <span class="total font-weight-bold">Quilometragem percorrida:</span>
          <span class="total font-weight-regular"
            >{{
              (vehicleRequest.endOdometer - vehicleRequest.beginOdometer)
                | metersToKm
            }}
            KM</span
          >
        </v-layout>
        <v-layout class="pt-3" justify-space-between>
          <span class="total font-weight-bold">Tempo de atraso:</span>
          <span class="total font-weight-regular"
            >{{ lagTime(vehicleRequest) }} MIN</span
          >
        </v-layout>
      </div>
    </div>
    <v-divider></v-divider>
    <!-- Para cada foto no banco -->
    <div v-for="form in formsAnswered" :key="form.answer">
      <div class="text-center pt-2">
        <img
          style="width: 100%"
          class="carImage"
          :src="`https://pickndrive.s3.amazonaws.com/${form.answer}`"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import FeedBackController from './../../controllers/FeedbackController';
import VehicleRequestController from '../../controllers/VehicleRequestController.js';
import FormAnsweredController from './../../controllers/FormAnsweredController.js';
import moment from 'moment';
import Constants from '../../models/constants/Constants';

export default {
  async created() {
    this.blockScreen = true;
    await this.feedBackController
      .getByVehicleRequestId(this.vehicleRequest.id)
      .then(res => {
        this.formFeedback = res;
        this.rating = this.formFeedback.form_date
          ? this.formFeedback.form_date.rating
          : 0;
      });
    // await this.getPrice()
    await this.getFormAnswered();
    this.blockScreen = false;
  },

  data() {
    return {
      feedBackController: new FeedBackController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),
      formAnsweredController: new FormAnsweredController(this.$resource),
      formFeedback: {},
      rating: 0,
      formsAnswered: null,
      blockScreen: true,
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
    };
  },

  filters: {
    money(str) {
      if (!str) return '0,00';
      str = parseFloat(str / 100).toFixed(2);
      if (str < 0) return '0,00';
      return str.replace('.', ',');
    },
    normalizeDate(date) {
      moment.locale('pt-Br');
      return moment(date).format('DD[/]MM[/]YYYY [-] HH:mm');
    },
    metersToKm(meters) {
      if (meters < 0) return '0,00';
      let km = (meters / 1000).toFixed(2);
      return km.toString().replace('.', ',');
    },
  },

  methods: {
    totalPrice(vehicleRequest) {
      return (
        Number.parseInt(vehicleRequest.penalty_value) +
        Number.parseInt(vehicleRequest.total_km_value) +
        Number.parseInt(vehicleRequest.reservation_value)
      );
    },

    lagTime(vehicleRequest) {
      let end_date_real = moment(vehicleRequest.end_date_real);
      let end_date = moment(vehicleRequest.end_date);
      if (moment(end_date_real).isAfter(end_date)) {
        return end_date_real.diff(end_date, 'minutes');
      }
      return 0;
    },

    changeDialog() {
      this.$emit('changeDialog');
    },
    // async getPrice(){
    //   await
    //     this.vehicleRequestController
    //     .getPricePreview(
    //       this.vehicleRequest.begin_date,
    //       this.vehicleRequest.end_date,
    //       this.vehicleRequest.vehicle_id,
    //       this.vehicleRequest.beginOdometer,
    //       this.vehicleRequest.endOdometer,
    //       this.vehicleRequest.end_date_real
    //     ).then( res => {
    //       this.price = res.body
    //     })
    //     .catch(error => {
    //       this.blockScreen = false
    //       console.log(error.body.message)
    //     })
    // },

    async getFormAnswered() {
      await this.formAnsweredController
        .getByVehicleRequestId(this.vehicleRequest)
        .then(res => {
          this.formsAnswered = res.data;
        });
    },
  },

  props: {
    vehicleRequest: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style>
.container {
  position: relative;
  height: 100vh;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.changePage {
  position: fixed;
  top: 48px;
  z-index: 1;
}

.sizeTop {
  height: 48px;
}

.bottom {
  margin-bottom: 60px;
}

.exit {
  position: fixed;
  right: 0;
  top: 0px;
}

.colorSelected {
  color: var(--secondary-color);
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}

.btnColor {
  background-color: var(--secondary-color) !important;
  color: var(--secondary-color) !important;
}

.float {
  position: absolute;
  color: var(--secondary-color);
  top: 0;
  right: 0;
}

.icon-size {
  font-size: 60px;
}

/* .newRequest {
  margin-top: 96px;
  margin-bottom: 56px;
}

.oldRequest {
  margin-top: 96px;
  margin-bottom: 56px;
} */

.moment {
  margin-bottom: 20px;
}

.vehicle {
  display: flex;
}

.modelo {
  font-size: 16px;
  color: #181f4d;
}

.caption {
  color: #181f4d;
}

.contentLeft {
  display: inline-block;
  width: 60%;
}

.cardContent > hr {
  width: 2px;
  height: 25px;
  margin: auto 0;
}

.contentRight {
  display: inline-block;
  width: 40%;
}

.vehicleImg {
  margin-left: -10px;
}

.cardRadius {
  border-radius: 4px;
}

.border {
  border: 2px solid grey;
}

.borderBottomIn {
  border-bottom: 1px solid var(--secondary-color);
}

.borderBottomOut {
  border-bottom: 1px solid var(--orange-color);
}

.cardContent {
  display: flex;
  justify-content: space-between;
}

.sizePart {
  width: 49%;
  text-align: center;
}

.checkin {
  background-color: var(--secondary-color) !important;
}

.checkin-text {
  color: var(--secondary-color);
}

.checkinBorder {
  border: 1px solid var(--secondary-color) !important;
}

.checkout {
  background-color: var(--orange-color) !important;
}

.checkout-text {
  color: var(--orange-color);
}

.checkoutBorder {
  border: 1px solid var(--orange-color) !important;
}

.total {
  color: #181f4d;
}

.carImage {
  border-radius: 6px;
}
</style>
